export { default as MMCQ } from './mmcq'


// WEBPACK FOOTER //
// ./src/quantizer/index.ts